<template>
    
    <div ref="sessionCardRef" class="absolute w-full flex justify-center" v-if="loading">                
        <ring-loader class="rounded-full bg-red-500" ></ring-loader> 
    </div>

    <div v-else @click="callShowDescription" class="text-xs lg:text-base">

        
        <div v-if="cardImages.length > 0" class="">

            <card-images-component :images="cardImages" ref="imageComponent" :isTransparent="true"
            :isFromMembershipCard="true"/>

        </div>

        <div class="myCenter" v-touch:swipe.left="swipeLeft" v-touch:swipe.right="swipeRight">

            <div class="membershipsCardDivClass">
                
                <card-details-component :membership="membership" :key="dayDate" :isOnline="true"
                :email="email" :myReload="myReload" :isCard="false" :displayModal="displayModal"
                :index="index" :dayDate="dayDate" 
                :disablePage="disablePage" :showDescription="showDescription" :showClassPage="showClassPage"
                :disableButton="disableButton" :openMembershipMapModal="openMembershipMapModal"/>
            </div>            
        </div>

        <div class="flex w-full h-24 lg:h-32 overflow-hidden">

            <div class="flex w-full h-24 lg:h-32 overflow-scroll">

                <div v-for="(item, i) in membership.three_studio_membership_to_schedules" :key="i" 
                class="h-24 lg:h-32">
                
                    <membership-schedule :schedule="item.three_studio_schedule"/>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

import { RingLoader } from 'vue-spinners-css';

import moment from 'moment';

import componentsHelpers from '../../classes/componentHelpers';

import cardImagesComponent from '../../components-v2/cards-components/CardImages'
import cardDetailsComponent from './StudioMembershipDetails'

import membershipSchedule from '../../components-v2/cards-components/MembershipScheduleDetails'
export default {

    created(){

    },

    mounted(){

        // console.log(`schedule: ${this.membership.three_studio_membership_to_schedules.length}`);
        const tempImages = new Array();

        tempImages.push(this.membership.image_1);
        tempImages.push(this.membership.image_2);
        tempImages.push(this.membership.image_3);
        tempImages.push(this.membership.image_4);

        tempImages.push(this.membership.image_5);
        tempImages.push(this.membership.image_6);
        tempImages.push(this.membership.image_7);
        tempImages.push(this.membership.image_8);

        for(let i = 0; i < 8; i++){
            
            if(tempImages[i] != ''){

                this.cardImages.push(tempImages[i]);
            }
        }

        if(this.cardImages.length == 0){

            this.cardImages.push(this.membership.business.logo);
        }
    },

    props: {

        index: -1,

        openMembershipMapModal: {

            type: Function
        },

        email: '',

        index: 0,

        showDescription: {

            type: Function
        },


        showClassPage: {

            type: Function
        },


        disablePage: false,

        disableButton: false,

        dayDate: '',

        membership:{

            type: Object
        },

        businessInfo:{
      
            type: Object,
        },

        instructors:{

            type: Array 
        },

        myReload: {

            type: Function
        },

        displayModal: {

            type: Function
        },
    },

    components:{

        RingLoader,
        cardImagesComponent,
        cardDetailsComponent,
        membershipSchedule
    },

    methods:{

        swipeLeft(){

            this.$refs.imageComponent.swipeLeft();
            // console.log(`swipeLeft`);
        },
        
        swipeRight(){

            this.$refs.imageComponent.swipeRight();

            // console.log(`swipeRight`);
        },  

        callShowDescription(){

            // console.log(`in callShowDescription`);

            // console.log(`here ${JSON.stringify(this.mySlot)}`);
            this.showDescription(this.membership);
        },

    },

    data: function(){

        return{

            loading:false,  
            myDayDate: this.dayDate,
            cardImages:[],
            modalImages: [],
        }
    },

}
</script>

<style>

</style>